module.exports = __webpack_public_path__ + "static/img/head10.ed77d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head10.png
// module id = Euzo
// module chunks = 1